export default __webpack_public_path__ + "static/media/README.65521e95.md";